import React from 'react'
import { MessageConfig, MessageType } from './Message.constants'
import {
  MessageContainer,
  MessageCTAButton,
  MessageContent,
  MessageText,
  MessageIcon,
} from './Message.styles'
import { MessageCTA } from './Message.types'

export const Message = ({
  messageType,
  messageText,
  ctaButton,
  size = 'small',
  padding = '16px',
}: {
  messageType: MessageType
  messageText: string
  ctaButton?: MessageCTA
  size?: 'small' | 'medium'
  padding?: string
}): JSX.Element => {
  const { icon, backgroundColor, borderColor } = MessageConfig[messageType]
  return (
    <MessageContainer
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      padding={padding}
    >
      <MessageContent>
        <MessageIcon $size={size}>{icon}</MessageIcon>
        <MessageText $size={size}>{messageText}</MessageText>
      </MessageContent>
      {ctaButton && (
        <MessageCTAButton
          onClick={ctaButton.onClick}
          $withMargin={ctaButton.withMargin}
          $size={size}
        >
          {ctaButton.text}
        </MessageCTAButton>
      )}
    </MessageContainer>
  )
}
